import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Moon } from "lucide-react";

/** Top-bar Halal Mode switch — same enforcement as Profile → Islamic account. */
export const HalalToggle = () => {
  const [on, setOn] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/halal/rules")
      .then(({ data }) => { if (alive) setOn(!!data.islamic_account); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const toggle = async (next) => {
    setBusy(true);
    const prev = on;
    setOn(next);
    try {
      const { data } = await api.post("/halal/mode", { islamic_account: next });
      toast[next ? "success" : "info"](next ? "Halal Mode on" : "Halal Mode off",
        { description: data.message });
    } catch (e) {
      setOn(prev);
      toast.error("Couldn't change Halal Mode", { description: e?.response?.data?.detail });
    } finally { setBusy(false); }
  };

  if (on === null) return null;

  return (
    <>
      {/* Mobile: compact tap target */}
      <button onClick={() => toggle(!on)} disabled={busy} title={`Halal Mode ${on ? "on" : "off"}`}
        data-testid="halal-mode-topbar-mobile"
        className={`lg:hidden nav-chip inline-flex items-center h-9 w-9 justify-center ${on ? "nav-chip-on" : ""}`}>
        <Moon className={`h-[18px] w-[18px] ${on ? "text-[color:var(--tharwy-indigo)]" : "text-muted-foreground"}`} />
      </button>

      {/* Desktop / tablet: labelled pill */}
      <div data-testid="halal-mode-topbar"
        className={`hidden lg:inline-flex items-center nav-chip ps-3 pe-2 gap-2 ${on ? "nav-chip-on" : ""}`}>
        <Moon className={`h-3.5 w-3.5 ${on ? "text-[color:var(--tharwy-indigo)]" : "text-muted-foreground"}`} />
        <span className="text-xs font-semibold whitespace-nowrap" data-testid="halal-mode-topbar-state">
          Halal {on ? "On" : "Off"}
        </span>
        <Switch checked={on} onCheckedChange={toggle} disabled={busy}
          className="scale-[0.8]" data-testid="halal-mode-topbar-switch" />
      </div>
    </>
  );
};
